import apiSlice from "./apiSlice";

const ncrDashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNcrKpiSummary: builder.query({
      query: ({ projectId }) => ({
        url: "ncr/kpi-summary",
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["NcrKpiSummary"],
    }),

    getNcrOpenByCategory: builder.query({
      query: ({ projectId }) => ({
        url: "ncr/open-by-category",
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["NcrOpenByCategory"],
    }),

    getNcrClosedAgeing: builder.query({
      query: ({ projectId }) => ({
        url: "ncr/closed-ageing",
        params: { projectId },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["NcrClosedAgeing"],
    }),

    getNcrFilteredList: builder.query({
        query: (params) => ({
          url: "ncr/filter",
          params,
        }),
        keepUnusedDataFor: 0,
        refetchOnMountOrArgChange: true,
        providesTags: ["NcrFilteredList"],
      }),
        }),
});

export const {
  useGetNcrKpiSummaryQuery,
  useGetNcrOpenByCategoryQuery,
  useGetNcrClosedAgeingQuery,
  useGetNcrFilteredListQuery,
} = ncrDashboardApiSlice;
